<template>
  <div>
    <FormKit
      ref="inputRef"
      v-bind="displayContext"
      v-model="model"
      type="togglebuttons"
      enforced="true"
      @input="onInput"
    >
      <template #label="context">
        <label :for="context.id" class="mb-4" :class="context.classes.label">{{ context.label }}</label>
        <FormKitMessages :node="(inputRef as any)?.node" />
      </template>
      <template #default="itemContext">
        <RadioCardListExpandableItem
          v-bind="itemContext.option"
          :isSelected="
            itemContext.option.__original !== undefined
              ? itemContext.option.__original === model
              : itemContext.option.value === model
          "
        />
      </template>
    </FormKit>

    <button v-if="!bindings.disabled" type="button" class="link text-base-bold mt-4" @click="showModal = true">
      {{ model ? 'Edit selection' : 'Show more' }}
    </button>

    <ModalDialog v-model="showModal" :closeOnEsc="true" :showXCloseButton="true" size="md">
      <RichText :field="modalTitle" class="sticky-modal-header" />
      <div class="tooltip-body">
        <FormKit
          v-bind="bindings"
          :id="bindings.name + '_modal'"
          v-model="modalModel"
          type="togglebuttons"
          enforced="true"
          label=""
          validation=""
        >
          <template #default="itemContext">
            <RadioCardListExpandableItem
              v-bind="itemContext.option"
              :isSelected="
                itemContext.option.__original !== undefined
                  ? itemContext.option.__original === modalModel
                  : itemContext.option.value === modalModel
              "
            />
          </template>
        </FormKit>
      </div>
      <div class="tooltip-footer">
        <FormKit
          type="button"
          inputClass="btn btn-primary btn-md w-full"
          label="Confirm"
          :disabled="!modalModel"
          @click="onInput(modalModel)"
        />
      </div>
    </ModalDialog>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { FormKit, FormKitMessages } from '@formkit/vue';
import type { VueFormInputProps } from '@/composables/useFormInputData';
import RadioCardListExpandableItem from './RadioCardListExpandableItem.vue';
import ModalDialog from '@/components/ModalDialog/ModalDialog.vue';
import { RichText, Field } from '@sitecore-jss/sitecore-jss-vue';
import { cloneDeep } from 'lodash-es';

const props = defineProps<{
  bindings: VueFormInputProps;
  initialOptionsCountToShow: number;
  modalTitle: Field<any>;
}>();

const model = defineModel<string>();
const modalModel = ref<string>();

const inputRef = ref(null);
const showModal = ref(false);
const displayContext = ref(cloneDeep(props.bindings));

if (props.initialOptionsCountToShow) {
  displayContext.value.options = displayContext.value.options.slice(0, props.initialOptionsCountToShow);
}

const onInput = (value?: string) => {
  if (!value) {
    displayContext.value.options = props.bindings.options.slice(0, props.initialOptionsCountToShow);
    return;
  }
  displayContext.value.options = props.bindings.options.filter((option: any) => option.value === value);
  model.value = value;
  showModal.value = false;
};
</script>
